import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const numFormatter = new Intl.NumberFormat('fi-FI', { maximumFractionDigits: 0 })
const pctFormatter = new Intl.NumberFormat('fi-FI', { style: 'percent', maximumFractionDigits: 1 })

const renderMetric = (label, current, previous) => {
  const has = current !== null && current !== undefined
  if (!has) {
    return (
      <Box sx={{ flex: 1 }}>
        <Box sx={{ fontSize: 11, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>{label}</Box>
        <Box sx={{ fontSize: 22, fontWeight: 600, color: 'text.disabled', mt: 0.5 }}>—</Box>
      </Box>
    )
  }
  const delta = current - (previous || 0)
  const pct = previous ? delta / previous : null
  const direction = delta > 0 ? 'up' : delta < 0 ? 'down' : 'flat'
  const color = direction === 'up' ? '#28a745' : direction === 'down' ? '#dc3545' : '#6c757d'
  const sign = delta > 0 ? '+' : delta < 0 ? '−' : ''
  return (
    <Box sx={{ flex: 1 }}>
      <Box sx={{ fontSize: 11, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>{label}</Box>
      <Box sx={{ fontSize: 22, fontWeight: 600, mt: 0.5 }}>{numFormatter.format(current)}</Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mt: 0.5, fontSize: 12, color }}>
        {direction === 'up' && <ArrowUpwardIcon sx={{ fontSize: 14 }} />}
        {direction === 'down' && <ArrowDownwardIcon sx={{ fontSize: 14 }} />}
        <span>
          {pct === null ? '—' : `${sign}${pctFormatter.format(Math.abs(pct))}`}
          {' '}
          ({sign}{numFormatter.format(Math.abs(delta))})
        </span>
      </Box>
    </Box>
  )
}

// data: { active: { current, previous }, new: { current, previous } }
const CustomerActivityCard = ({ title = 'Asiakkaat', data, loading }) => {
  const active = (data && data.active) || { current: null, previous: null }
  const newC = (data && data.new) || { current: null, previous: null }
  const hasData = active.current !== null && active.current !== undefined

  return (
    <Card sx={{ borderRadius: 2, height: '100%' }}>
      <CardContent sx={{ p: '12px 14px', '&:last-child': { pb: '12px' } }}>
        <Typography variant='caption' sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>
          {title}
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 110 }}>
            <CircularProgress size={20} />
          </Box>
        ) : !hasData ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 110, color: 'text.secondary', fontSize: 12, textAlign: 'center', px: 2 }}>
            Asiakaslaskuri vaatii backend-päivityksen.<br />Tieto ilmestyy heti, kun palvelin lähettää sen.
          </Box>
        ) : (
          <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
            {renderMetric('Aktiivisia', active.current, active.previous)}
            {renderMetric('Uusia', newC.current, newC.previous)}
          </Box>
        )}
        {!loading && hasData && (
          <Box sx={{ fontSize: 11, color: 'text.secondary', mt: 1 }}>vs viime kuukausi</Box>
        )}
      </CardContent>
    </Card>
  )
}

export default CustomerActivityCard
